module.exports = __webpack_public_path__ + "img/44.e65c6b96.png";